import React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import { pay2, pay3, pay4, visa } from "../../assets/imagesPath";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": { color: "#aab7c4" },
    },
    invalid: { color: "#fa755a", iconColor: "#fa755a" },
  },
};
const CardSection = () => {
  return (
    <div className="rounded-xl p-3 space-y-6 relative bg-[#F2F2F282]">
      <label className="block text-[#737373] text-[1.6rem]">Card Information</label>
      <CardElement options={CARD_ELEMENT_OPTIONS} className="p-4 border rounded-md bg-[#F2F2F282]" />
      <div className="flex space-x-4 absolute top-1 right-6">
        <img src={visa} className=" h-8" alt="Visa" />
        <img src={pay2} className=" h-8" alt="pay2" />
        <img src={pay3} className=" h-8" alt="pay3" />
        <img src={pay4} className=" h-8" alt="pay4" />
      </div>
    </div>
  );
};
export default CardSection;
